import { Directive, ElementRef, forwardRef, inject, Renderer2 } from '@angular/core';
import { DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const LOWERCASE_INPUT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LowerCaseInputDirective),
  multi: true,
};

@Directive({
  selector: 'input[lowercase]',
  standalone: true,
  host: {
    // When the user updates the input
    '(input)': 'onInput($any($event.target).value)',
    '(blur)': 'onTouched()',
  },
  providers: [LOWERCASE_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class LowerCaseInputDirective extends DefaultValueAccessor {
  constructor() {
    const renderer = inject(Renderer2);
    const elementRef = inject(ElementRef);

    super(renderer, elementRef, false);
  }

  writeValue(value: any): void {
    const transformed = this.transformValue(value);

    super.writeValue(transformed);
  }

  onInput(value: any): void {
    const transformed = this.transformValue(value);

    super.writeValue(transformed);
    this.onChange(transformed);
  }

  private transformValue(value: any): any {
    const result = value && typeof value === 'string' ? value.toLowerCase() : value;

    return result;
  }
}
